import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["carrier", "category", "name", "status"];

  // Stimulus 2 has no keyboard event filters (`keyup.enter`), so the key is checked here.
  filterOnEnter(event) {
    if (event.key !== "Enter") return;

    this.filter();
  }

  filter() {
    const filters = {
      carrier: this.carrierTarget.value,
      category: this.categoryTarget.value,
      name: this.nameTarget.value,
      status: this.statusTarget.value
    };
    this.stimulate("PremiumAdjustmentRuleReflex#filter", filters);
  }
}
